import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {ItemAtendimento, ListaAtendimento} from "../../models/lista-atendimento";
import {AtendimentoService} from "../../services/atendimento.service";
import {ToastrService} from "ngx-toastr";
import { NovoComponent } from '../novo/novo.component';
import { DetalhesComponent } from '../detalhes/detalhes.component';

@Component({
    selector: 'app-lista',
    templateUrl: './lista.component.html',
    styleUrl: './lista.component.css',
    standalone: false
})
export class ListaComponent {
  @ViewChild(NovoComponent) novoComponente: NovoComponent;
  @ViewChild(DetalhesComponent) detalhesComponente: DetalhesComponent;
  loading = true;
  listaAtendimento = new ListaAtendimento();
  paginaAtual = 1;

  constructor(private atendimentoService: AtendimentoService,
              private toastr: ToastrService,
              private route: ActivatedRoute) {
    this.buscarListaAtendimentos();

    this.route.queryParams.subscribe(params => {
      const detalheId = Number(params['detalheId']);
      if (detalheId) {
        // Abrir modal de detalhes automaticamente quando chamado com queryParam
        setTimeout(() => this.abrirModalDetalhes(detalheId));
      }
    });
  }

  abrirModal(){
    this.novoComponente.showModalNovoAtendimento();
  }

  abrirModalDetalhes(id: number){
    this.detalhesComponente.abrirModal(id);
  }

  buscarListaAtendimentos(){
    this.atendimentoService.selecionarLista().subscribe(
          response => {
            this.listaAtendimento = response.dados;
            this.loading = false;
          },
          (error: any) => {
            this.toastr.error('Erro ao listar atendimentos');
            this.loading = false;
          }
        );
  }

}
